import React, {useEffect, useRef, useState} from 'react';
import emailjs from '@emailjs/browser';
import logo from './assets/logo.svg';
import './App.css';
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import arrowRight from './assets/arrow-right.svg';
import arrowLeft from './assets/arrow-left.svg';
import {Autoplay, Navigation} from "swiper/modules";
import ig from './assets/ig.svg';
import fb from './assets/fb.svg';
import ln from './assets/ln.svg';
import case2 from './assets/Obrnuti oglas za posao_full hd.png';
import case3 from './assets/Osetljiva mu koza_full hd.jpg';
import case4 from './assets/Delta District_full hd.png';
import case5 from './assets/Dis NasaApp_full hd.png';
import case6 from './assets/Cacanski cips_full hd.jpg';
import team1 from './assets/1Slika_900x1200px.jpg';
import team2 from './assets/2Slika_900x1200px.jpg';
import team3 from './assets/3Slika_900x1200px.jpg';
import team4 from './assets/4Slika_900x1200px.jpg';
import team5 from './assets/5Slika_900x1200px.jpg';
import team6 from './assets/6Slika_900x1200px.jpg';
import team7 from './assets/7Slika_900x1200px_.jpg';
import team8 from './assets/8Slika_900x1200px_.jpg';
import team9 from './assets/9Slika_900x1200px.jpg';
import ref1 from './assets/ref1.svg';
import ref2 from './assets/ref2.svg';
import ref3 from './assets/ref3.png';
import ref4 from './assets/ref4.svg';
import ref5 from './assets/ref5.png';
import ref6 from './assets/ref6.svg';
import ref7 from './assets/ref7.svg';
import ref8 from './assets/ref8.svg';
import ref9 from './assets/ref9.svg';
import ref10 from './assets/ref10.svg';
import ref11 from './assets/ref11.svg';
import ref12 from './assets/ref12.svg';
import ref13 from './assets/ref13.svg';
import ref14 from './assets/ref14.svg';
import ref15 from './assets/ref15.svg';
import ref16 from './assets/ref16.svg';
import ref17 from './assets/ref17.svg';
import ref18 from './assets/ref18.svg';
import ref19 from './assets/ref19.svg';
import ref20 from './assets/ref20.svg';
import ref21 from './assets/ref21.svg';
import ref22 from './assets/ref22.svg';
import ref23 from './assets/ref23.svg';
import ref24 from './assets/ref24.svg';
import ref25 from './assets/ref25.svg';
import ref26 from './assets/ref26.svg';
import ref27 from './assets/ref27.svg';
import obrnuti from './assets/obrnuti.svg';
import mtp from './assets/meet-the-process.png';
import mtpMobile from './assets/mtp-mobile.png';
import {Modal} from 'react-bootstrap';
import desktopVideo from './assets/video-mob.mp4';
import mobileVideo from './assets/video-desk.mp4';
import {BrowserRouter, useLocation, useNavigate, useNavigation} from "react-router-dom";
import brief from './assets/Evoke Marketing Agency - Brief.pdf';

type Language = 'en' | 'sr';
interface TranslationContent {
    contact: string;
    heroH11: string;
    heroH12: string;
    heroH13: string;
    case1: string;
    case2: string;
    servicesH1: string;
    servicesH2: string;
    servicesH3: string;
    services1Title: string;
    services1Content: string;
    services1Li1: string;
    services1Li2: string;
    services1Li3: string;
    services1Li4: string;
    services1Li5: string;
    services2Title: string;
    services2Content: string;
    services2Li1: string;
    services2Li2: string;
    services2Li3: string;
    services2Li4: string;
    services2Li5: string;
    services3Title: string;
    services3Content: string;
    services3Li1: string;
    services3Li2: string;
    services3Li3: string;
    services3Li4: string;
    services3Li5: string;
    services4Title: string;
    services4Content: string;
    services4Li1: string;
    services4Li2: string;
    services4Li3: string;
    services4Li4: string;
    services4Li5: string;
    team1: string;
    team2: string;
    team3: string;
    clients1: string;
    clients2: string;
    footer1: string;
    footer12: string;
    footer2: string;
    footer3: string;
    seeMore: string;
    seeLess: string;
    form1: string;
    form2: string;
    form3: string;
    form4: string;
    confirmation1: string;
    confirmation2: string;
    legal1: string;
    legal2: string;
    legal3: string;
    legal4: string;
    legal5: string;
    legal6: string;
    legal7: string;
    legal8: string;
    pitch: string;
    job1: string;
    job2: string;
    job3: string;
    job4: string;
    job5: string;
    job6: string;
    job7: string;
    job8: string;
    job9: string;
    job10: string;
    job11: string;
    job12: string;
    job13: string;
    job14: string;
    job21: string;
    job131: string;
}

function App() {
    useEffect(() => emailjs.init("22cr1i-2j9w7OcZ9r"), []);

    const swiper = useRef<any>(null);
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const prevRef2 = useRef<HTMLImageElement>(null);
    const nextRef2 = useRef<HTMLImageElement>(null);
    const galleryRef = useRef<HTMLDivElement>(null);
    const lastScrollY = useRef<number>(window.scrollY);
    const [offset, setOffset] = useState(0);

    const nameRef = useRef<HTMLInputElement>(null);
    const emailRef = useRef<HTMLInputElement>(null);
    const messageRef = useRef<HTMLTextAreaElement>(null);

    const [open, setOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const [isOpen4, setIsOpen4] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
    const contentRef2 = useRef<HTMLDivElement>(null);
    const contentRef3 = useRef<HTMLDivElement>(null);
    const contentRef4 = useRef<HTMLDivElement>(null);

    const [showContent, setShowContent] = useState(false);
    const [lang, setLang] = useState<Language>('en');

    const [show, setShow] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [homeShown, setHomeShown] = useState(true);
    const [legalShown, setLegalShown] = useState(false);
    const [pitchShown, setPitchShown] = useState(false);
    const [jobShown, setJobShown] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/legal') {
            setLegalShown(true);
            setPitchShown(false);
            setHomeShown(false);
            setJobShown(false);
        } else if(location.pathname === '/obrnuti-pitch') {
            setLegalShown(false);
            setPitchShown(true);
            setHomeShown(false);
            setJobShown(false);
            setLang('sr');
        } else if(location.pathname === '/content-creator') {
            setLegalShown(false);
            setPitchShown(false);
            setHomeShown(false);
            setJobShown(true);
            setLang('sr');
        } else {
            setLegalShown(false);
            setPitchShown(false);
            setHomeShown(true);
            setJobShown(false);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (legalShown) {
            navigate('/legal', { replace: true });
        } else if(pitchShown) {
            navigate('/obrnuti-pitch', { replace: true });
        } else if(homeShown) {
            navigate('/', { replace: true });
        } else if(jobShown) {
            navigate('/content-creator', { replace: true });
        }
    }, [legalShown, pitchShown, homeShown, navigate, jobShown]);

    const translations: Record<Language, TranslationContent> = {
        en: {
            contact: 'Contact',
            heroH11: 'Strategically driven business',
            heroH12: 'growth through full-service',
            heroH13: 'marketing activities.',
            case1: 'Fueled by insight,',
            case2: 'built by creativity.',
            servicesH1: 'Partnership-driven',
            servicesH2: 'services and',
            servicesH3: 'activities',
            services1Title: 'STRATEGY',
            services1Content: 'Strategic clarity is where we start. Working closely with our clients, we uncover what truly moves their audiences—then shape narratives, plans, and platforms that deliver real impact across every touchpoint.',
            services1Li1: 'Brand analysis and goal setting',
            services1Li2: 'Target audience, market, and competitor research',
            services1Li3: 'Brand strategy and positioning',
            services1Li4: 'Marketing strategy and business support',
            services1Li5: 'Communication strategy',
            services2Title: 'CREATIVE',
            services2Content: 'Creativity is where strategy comes to life. We co-create with our clients, turning sharp insights into ideas that are not only beautiful and bold—but relevant, memorable, and made to perform.',
            services2Li1: 'Verbal brand identity',
            services2Li2: 'Visual brand identity',
            services2Li3: 'Creative campaigns and concepts',
            services2Li4: 'Art direction and visual guidelines',
            services2Li5: 'UX/UI design for web and apps',
            services3Title: 'PRODUCTION',
            services3Content: 'We produce with care, speed, and intent. Our agile setup means we stay close to the creative—and even closer to the client—to deliver content that’s smart, polished, and ready to perform.',
            services3Li1: 'Photo, video, and audio production',
            services3Li2: 'Post-production',
            services3Li3: 'Motion design and animation',
            services3Li4: 'Print and digital content production',
            services3Li5: 'Website and app production',
            services4Title: 'ADVERTISING',
            services4Content: 'We run ads with intent. Whether brand-building or performance-driven, our campaigns are agile, optimized in real time, and built to grow with your goals.',
            services4Li1: 'Media planning and buying',
            services4Li2: 'Campaign management and optimization',
            services4Li3: 'PR and strategic communications',
            services4Li4: 'Influencer and KOL activations',
            services4Li5: '360° integrated campaigns',
            team1: 'We work with heart, think strategically, and live creatively.',
            team2: 'From business innovation to pop culture — we like to be where things happen, because we know the best insights are born where real people live.',
            team3: 'We love working with clients, not for them. We\'re always open to ideas, collaboration, and shared thinking. We see the bigger picture, and we don’t close doors — literally or figuratively.',
            clients1: 'Our clients',
            clients2: 'We’re proud to have worked with over 100 companies across nearly every industry, in more than 10 countries — primarily throughout the Adria region.',
            footer1: 'Here, we stop talking and ',
            footer12: 'start listening.',
            footer2: 'Send message',
            footer3: 'Evoke Marketing Agency 2025',
            seeMore: 'See more ↓',
            seeLess: 'See less ↑',
            form1: 'Name',
            form2: 'Email',
            form3: 'Message',
            form4: 'Send',
            confirmation1: 'Thanks for reaching out! We’ll get back to you',
            confirmation2: 'as soon as possible.',
            legal1: 'Business name',
            legal2: 'Bank account number',
            legal3: 'Address',
            legal4: 'PIB',
            legal5: 'Social security number',
            legal6: 'Email',
            legal7: 'Code and name of activity',
            legal8: 'Advertising agency activities',
            pitch: 'Reverse pitch',
            job1: 'WE ARE EVOKING: Content Creator 🚀',
            job2: 'Forget about a „dynamic work environment“. At Evoke, we offer what actually matters: ',
            job21: 'The Backyard.',
            job3: 'We aren’t looking for someone who just „does the job“. We’re looking for someone who can’t sit still. More specifically, you’re our person if:',
            job4: 'Your TikTok screen time is a serious red flag (and you’re proud of it).',
            job5: 'While you scroll, your brain is already engineering trends for our clients.',
            job6: 'Editing apps and software are your natural habitat; you edit faster than lunch arrives at the office.',
            job7: 'You are an independent and proactive person. You don’t wait for the brief, you create it yourself.',
            job8: 'Shyness is a foreign concept to you. As soon as you see a lens, the performance begins.',
            job9: 'What awaits you (besides The Backyard):',
            job10: 'The crew and the humor: From Andrijana’s “judging” look to internal Slack roasts, humor is our core value.',
            job11: 'A safe zone for crazy ideas: Test, film, fail. We move on, as long as we’ve learned something.',
            job12: 'We work with big clients, but without ties and unnecessary formalism.',
            job13: 'Send a link to your portfolio/profile or (even better) a video up to 60s to ',
            job131: 'Show us your edit, show us your energy, show us who you are.',
            job14: 'See you in The Backyard.'
        },
        sr: {
            contact: 'Kontakt',
            heroH11: 'Strateški vođen rast',
            heroH12: 'poslovanja kroz full-service',
            heroH13: 'marketing aktivnosti.',
            case1: 'Pokreće nas uvid,',
            case2: 'oblikuje nas kreativnost.',
            servicesH1: 'Partnerski usmerene',
            servicesH2: 'usluge i',
            servicesH3: 'aktivnosti',
            services1Title: 'STRATEGIJA',
            services1Content: 'Naša polazna tačka je jasna strategija. Kroz blisku saradnju sa klijentima i istraživanje otkrivamo šta zaista pokreće njihove korisnike, brend i biznis, a zatim kreiramo priče, planove i platforme koje donose stvarne rezultate.',
            services1Li1: 'Analiza brenda i definisanje ciljeva',
            services1Li2: 'Istraživanje ciljne grupe, konkurencije i tržišta',
            services1Li3: 'Brend strategija i pozicioniranje',
            services1Li4: 'Marketing strategija i podrška biznisu',
            services1Li5: 'Komunikaciona strategija',
            services2Title: 'KREATIVA',
            services2Content: 'Kreativni proces je mesto gde naša strategija dobija oblik. U ko-kreaciji sa klijentima, pretvaramo uvide u ideje, koje nisu samo upečatljive i hrabre, već i relevantne, pamtljive i kreirane da ostvare rezultate.',
            services2Li1: 'Verbalni identitet brenda',
            services2Li2: 'Vizuelni identitet brenda',
            services2Li3: 'Kreativne kampanje i koncepti',
            services2Li4: 'Art direkcija i vizuelne smernice',
            services2Li5: 'UX/UI dizajn za web i aplikacije',
            services3Title: 'PRODUKCIJA',
            services3Content: 'Kreiramo pažljivo i sa jasnom svrhom, ali efektno i upečatljivo. Naš agilni pristup omogućava nam da isporučimo sadržaj koji je kvaliteta, kreativan i spreman da ostvari rezultate.',
            services3Li1: 'Foto, video i audio produkcija',
            services3Li2: 'Postprodukcija',
            services3Li3: 'Motion dizajn i animacija',
            services3Li4: 'Produkcija print i digital sadržaja',
            services3Li5: 'Produkcija veb sajtova i aplikacija',
            services4Title: 'OGLAŠAVANJE',
            services4Content: 'Kampanje koje kreiramo su vođene strategijom i svrhom. Bilo da su fokusirane na jačanje brenda ili na konkretnim performansama, naše kampanje odlikuje agilnost, stalna optimizacija i usklađenost sa poslovnim i brend ciljevima.',
            services4Li1: 'Medijsko planiranje i zakup',
            services4Li2: 'Upravljanje i optimizacija kampanja',
            services4Li3: 'PR i strateška komunikacija',
            services4Li4: 'Influencer i KOL aktivacije',
            services4Li5: '360 integrisane kampanje',
            team1: 'Radimo sa strašću, pristupamo strateški i stvaramo kreativno.',
            team2: 'Od poslovnih inovacija do pop kulture — volimo da budemo u srcu zbivanja, jer najbolje uvide pronalazimo tamo gde su ljudi.',
            team3: 'Volimo da radimo sa klijentima, a ne za njih. Uvek smo otvoreni za ideje, saradnju i razmenu mišljenja. Vidimo širu sliku i ne zatvaramo vrata — ni bukvalno, ni u prenesenom značenju.',
            clients1: 'Naši klijenti',
            clients2: 'Ponosni smo što smo sarađivali sa više od 100 kompanija iz gotovo svih industrija, u više od 10 zemalja — pretežno u Adria regiji.',
            footer1: 'Ovde prestajemo da govorimo i ',
            footer12: 'počinjemo da slušamo.',
            footer2: 'Pošalji poruku',
            footer3: 'Evoke marketing agencija',
            seeMore: 'Prikaži više ↓',
            seeLess: 'Prikaži manje ↑',
            form1: 'Ime i prezime',
            form2: 'Email',
            form3: 'Poruka',
            form4: 'Pošalji',
            confirmation1: 'Hvala vam na upitu! Javićemo vam se u najkraćem mogućem roku',
            confirmation2: '(da ne kažemo, ASAP).',
            legal1: 'Poslovno ime',
            legal2: 'Račun',
            legal3: 'Adresa',
            legal4: 'PIB',
            legal5: 'Matični broj',
            legal6: 'Email',
            legal7: 'Šifra i naziv delatnosti',
            legal8: 'Delatnost reklamnih agencija',
            pitch: 'Obrnuti pitch',
            job1: 'WE ARE EVOKING: Content Creator 🚀',
            job2: 'Zaboravi na „dinamično radno okruženje“. U Evoke-u nudimo ono što je zapravo bitno: ',
            job21: 'Dvorište.',
            job3: 'Ne tražimo nekoga ko samo „odrađuje posao“. Tražimo nekoga koga ne drži mesto. Konkretnije, ti si naš čovek ako:',
            job4: 'Tvoj screen time na TikToku je ozbiljan red flag (i ponosiš se time).',
            job5: 'Dok skroluješ, tvoj mozak već radi engineering trenda za naše klijente.',
            job6: 'Aplikacije i programi za editovanje su ti prirodno stanište, edituješ brže nego što ručak stiže do kanca.',
            job7: 'Samostalna si i proaktivna osoba. Ne čekaš brif, stvaraš ga sama.',
            job8: 'Stidljivost ti je nepoznat pojam. Čim vidiš objektiv, kreće performans.',
            job9: 'Šta te čeka (osim Dvorišta):',
            job10: 'Ekipa i humor: Od Andrijaninog “judging” pogleda do internih Slack rostova, humor nam je core vrednost.',
            job11: 'Safe zone za lude ideje: Testiraj, snimi, promaši. Idemo dalje, bitno da smo nešto naučili.',
            job12: 'Radimo sa velikim klijentima, ali bez kravata i nepotrebnog formalizma.',
            job13: 'Pošalji na ',
            job131: 'link ka svom portfoliju/profilu ili (još bolje) snimi video do 60s. Pokaži nam edit, pokaži nam energiju, pokaži nam ko si.',
            job14: 'Vidimo se u Dvorištu.'
        },
    };

    const toggleLanguage = () => {
        setLang(prev => (prev === 'en' ? 'sr' : 'en'));
    };

    const showLegal = () => {
        setLegalShown(true);
        setPitchShown(false);
        setHomeShown(false);
        setJobShown(false);
    }

    const showHome = () => {
        setLegalShown(false);
        setPitchShown(false);
        setHomeShown(true);
        setJobShown(false);
    }

    const showPitch = () => {
        setLegalShown(false);
        setPitchShown(true);
        setHomeShown(false);
        setLang('sr');
        setJobShown(false);
    }

    const hideLegal = () => {
        setLegalShown(false);
    }

    const showJob = () => {
        setLegalShown(false);
        setPitchShown(false);
        setHomeShown(false);
        setJobShown(true);
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            setShowContent(true);
        }, 6500);

        return () => clearTimeout(timeout);
    }, []);

    const toggleServices = () => {
        setIsOpen(!isOpen);
    };

    const toggleServices2 = () => {
        setIsOpen2(!isOpen2);
    };

    const toggleServices3 = () => {
        setIsOpen3(!isOpen3);
    };

    const toggleServices4 = () => {
        setIsOpen4(!isOpen4);
    };

    const form = useRef<HTMLFormElement>(null);
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const serviceId = "service_tkpma9m";
        const templateId = "template_q0xc6hy";
        try {
            await emailjs.send(serviceId, templateId, {
                name: nameRef.current != undefined ? nameRef.current?.value: '',
                email: emailRef.current != undefined ? emailRef.current?.value: '',
                message: messageRef.current != undefined ? messageRef.current?.value: '',
                recipient: 'office@evokegroup.rs'
            });

            if (nameRef.current) nameRef.current.value = 'Janko';
            if (emailRef.current) emailRef.current.value = 'janko@janko.com';
            if (messageRef.current) messageRef.current.value = 'TEST';

            setSubmitted(true);
        } catch (error) {
            console.log(error);
            alert("Poruka nije uspešno poslata!");
        } finally {
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (!galleryRef.current) return;

            const rect = galleryRef.current.getBoundingClientRect();
            const inView = rect.top < window.innerHeight && rect.bottom > 0;

            if (inView) {
                const currentScrollY = window.scrollY;
                const direction = currentScrollY > lastScrollY.current ? -1 : 1;
                setOffset((prev) => Math.max(-320, Math.min(320, prev + direction * 3))); // max -20 to 20 px
                lastScrollY.current = currentScrollY;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            {pitchShown && (
                <>
                    <div className="header">
                        <a className="logo" href="#" onClick={showHome}><img src={logo} alt="evoke logo"/></a>
                        <div className={`burger ${open ? 'active' : ''}`} onClick={() => setOpen(!open)}>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>

                    <div className={`menu ${open ? 'show' : ''}`}>
                        <a href="#" onClick={showPitch}>{translations[lang].pitch}</a>
                        <a href="#contact">{translations[lang].contact}</a>
                        <a href="#" onClick={showLegal}>Legal</a>
                        <a href="#" onClick={toggleLanguage}>{lang === 'en'? 'SRB': 'EN'}</a>
                    </div>

                    <header>
                        <a className="logo" href="#" onClick={showHome}><img src={logo} alt="evoke logo"/></a>
                        <div className="right-nav">
                            <a href="#" onClick={showPitch}>{translations[lang].pitch}</a>
                            <a href="#contact">{translations[lang].contact}</a>
                            <a href="#" onClick={showLegal}>Legal</a>
                            <a href="#" onClick={toggleLanguage}>{lang === 'en'? 'SRB': 'EN'}</a>
                        </div>
                    </header>

                    <section id="obrnuti-hero">
                        <div className="row">
                            <div className="col-md-4">
                                <h1>Obrnuti pitch?</h1>
                                <p>Naš način da stvorimo prilike za <br/>ljude i ideje koje vrede.</p>
                                <a target="_blank" href={brief}>Preuzmi brif</a>
                            </div>
                            <div className="col-md-8">
                                <img src={obrnuti} alt="obrnuti pitch" className="img-responsive" />
                            </div>
                        </div>
                    </section>

                    <section id="why">
                        <h2>Zašto ovo radimo?</h2>
                        <div className="row">
                            <div className="col-md-6">
                                <p>Nećemo da se pravimo da je sve sjajno. Kriza je prisutna - u zemlji, u industriji, u svakom poslu. Mi verujemo da upravo u takvim vremenima treba biti još hrabriji i iskreniji. <br/><br/>Iz tog razloga, odlučili smo da okrenemo stvari naglavačke: umesto da čekamo pitch pozive i skrivamo se iza formalnih procesa, mi pokrećemo Obrnuti pitch.</p>
                            </div>
                            <div className="col-md-6">
                                <p>Ova inicijativa inspirisana je našom nagrađivanom kampanjom <a target="_blank" href="https://www.youtube.com/watch?v=Ntt-NUtTpTU">Obrnuti oglas za posao</a> - kada smo mi, umesto kandidata, objavili svoj CV, motivacioni video i motivaciono pismo. <br/><br/>Sada isti princip primenjujemo na odnos agencija-klijent.</p>
                            </div>
                        </div>
                    </section>

                    <section id="why" className="why-1">
                        <h2>Kako izgleda proces?</h2>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="card-cus">
                                    <h5>01</h5>
                                    <h4>Preuzmi brif</h4>
                                    <p>Ako ti ovo zvuči interesantno <a target="_blank" href={brief}>Preuzmi brif</a></p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card-cus">
                                    <h5>02</h5>
                                    <h4>DISCOVERY CALL</h4>
                                    <p>Ako nakon čitanja brifa misliš da smo match zakazujemo otvoren razgovor o vašim potrebama i našim kapacitetima.</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card-cus">
                                    <h5>03</h5>
                                    <h4>DISCOVERY WORKSHOP</h4>
                                    <p>Ako kliknemo, idemo dalje - kroz Discovery Workshop definišemo specifikaciju saradnje i projekata.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section id="why" className="why-2">
                        <h2>Šta možete da očekujete?</h2>
                        <p><strong>Transparentnost</strong>: otvoreno pokazujemo naše kapacitete i način rada. <br/><br/><strong>Fokus</strong>: tražimo klijente sa kojima možemo da rastemo i gde imamo priliku da istinski utičemo na ostvarenje biznis ciljeva. <br/><br/><strong>Razumevanje</strong>: verujemo da prava rešenja dolaze tek kada duboko razumemo širu sliku i sve uključene interesne strane.</p>
                    </section>

                    <section id="pitch-form">
                        <h3>Obrnuti pitch je naš poziv <br/>na iskren razgovor.</h3>
                        <p>Ako verujete u drugačiji način saradnje, radujemo se prilici <br/>da se upoznamo i sarađujemo!</p>
                        <a onClick={handleShow}>Pošalji poruku</a>
                    </section>

                    <footer id="contact">
                        <div className="top-footer">
                            {/*<h4>{translations[lang].footer1}<br/>{translations[lang].footer12}</h4>*/}
                            {/*<button onClick={handleShow}>{translations[lang].footer2}</button>*/}
                        </div>
                        <div className="bottom-footer">
                            <div className="socials">
                                <img src={logo} alt="evoke logo"/>
                                <div>
                                    <a href="https://www.instagram.com/evoke.marketing.agency/?hl=en" target="_blank"><img src={ig} alt="evoke instagram"/></a>
                                    <a href="https://www.facebook.com/evoke.marketing.agency/" target="_blank"><img src={fb} alt="evoke facebook"/></a>
                                    <a href="https://rs.linkedin.com/company/evoke-rs" target="_blank"><img src={ln} alt="evoke linkedin"/></a>
                                </div>
                            </div>
                            <p>© {translations[lang].footer3}</p>
                        </div>
                    </footer>
                </>
            )}

            {legalShown && (
                <>
                    <div className="header">
                        <a className="logo" href="#" onClick={showHome}><img src={logo} alt="evoke logo"/></a>
                        <div className={`burger ${open ? 'active' : ''}`} onClick={() => setOpen(!open)}>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>

                    <div className={`menu ${open ? 'show' : ''}`}>
                        <a href="#" onClick={showPitch}>{translations[lang].pitch}</a>
                        <a href="#contact">{translations[lang].contact}</a>
                        <a href="#" onClick={showLegal}>Legal</a>
                        <a href="#" onClick={toggleLanguage}>{lang === 'en'? 'SRB': 'EN'}</a>
                    </div>

                    <header>
                        <a className="logo" href="#" onClick={showHome}><img src={logo} alt="evoke logo"/></a>
                        <div className="right-nav">
                            <a href="#" onClick={showPitch}>{translations[lang].pitch}</a>
                            <a href="#contact">{translations[lang].contact}</a>
                            <a href="#" onClick={showLegal}>Legal</a>
                            <a href="#" onClick={toggleLanguage}>{lang === 'en'? 'SRB': 'EN'}</a>
                        </div>
                    </header>

                    <section id="legal">
                        <p><strong>{translations[lang].legal1}: </strong>Evoke d.o.o. </p>
                        <p><strong>{translations[lang].legal3}: </strong>Trg Nikole Pašića 7, 11000 Beograd</p>
                        <p><strong>{translations[lang].legal4}: </strong>111050410</p>
                        <p><strong>{translations[lang].legal5}: </strong>21418676</p>
                        <p><strong>{translations[lang].legal2}: </strong>265-1680310001701-97 - Raiffeisen banka</p>
                        <p><strong>{translations[lang].legal7}: </strong>7311 - {translations[lang].legal8}</p>
                        <p><strong>{translations[lang].legal6}: </strong>office@evoke.rs</p>
                    </section>

                    <footer id="contact">
                        <div className="top-footer">
                            <h4>{translations[lang].footer1}<br/>{translations[lang].footer12}</h4>
                            <button onClick={handleShow}>{translations[lang].footer2}</button>
                        </div>
                        <div className="bottom-footer">
                            <div className="socials">
                                <img src={logo} alt="evoke logo"/>
                                <div>
                                    <a href="https://www.instagram.com/evoke.marketing.agency/?hl=en" target="_blank"><img src={ig} alt="evoke instagram"/></a>
                                    <a href="https://www.facebook.com/evoke.marketing.agency/" target="_blank"><img src={fb} alt="evoke facebook"/></a>
                                    <a href="https://rs.linkedin.com/company/evoke-rs" target="_blank"><img src={ln} alt="evoke linkedin"/></a>
                                </div>
                            </div>
                            <p>© {translations[lang].footer3}</p>
                        </div>
                    </footer>
                </>
            )}

            {jobShown && (
                <>
                    <div className="header">
                        <a className="logo" href="#" onClick={showHome}><img src={logo} alt="evoke logo"/></a>
                        <div className={`burger ${open ? 'active' : ''}`} onClick={() => setOpen(!open)}>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>

                    <div className={`menu ${open ? 'show' : ''}`}>
                        <a href="#" onClick={showPitch}>{translations[lang].pitch}</a>
                        <a href="#contact">{translations[lang].contact}</a>
                        <a href="#" onClick={showLegal}>Legal</a>
                        <a href="#" onClick={toggleLanguage}>{lang === 'en'? 'SRB': 'EN'}</a>
                    </div>

                    <header>
                        <a className="logo" href="#" onClick={showHome}><img src={logo} alt="evoke logo"/></a>
                        <div className="right-nav">
                            <a href="#" onClick={showPitch}>{translations[lang].pitch}</a>
                            <a href="#contact">{translations[lang].contact}</a>
                            <a href="#" onClick={showLegal}>Legal</a>
                            <a href="#" onClick={toggleLanguage}>{lang === 'en'? 'SRB': 'EN'}</a>
                        </div>
                    </header>

                    <section id="legal" className="content-creator">
                        <h1>{translations[lang].job1}</h1>
                        <p>{translations[lang].job2} {translations[lang].job21}</p>
                        <p>{translations[lang].job3}</p>
                        <ul>
                            <li>{translations[lang].job4}</li>
                            <li>{translations[lang].job5}</li>
                            <li>{translations[lang].job6}</li>
                            <li>{translations[lang].job7}</li>
                            <li>{translations[lang].job8}</li>
                        </ul>
                        <p>{translations[lang].job9}</p>
                        <ul>
                            <li>{translations[lang].job10}</li>
                            <li>{translations[lang].job11}</li>
                            <li>{translations[lang].job12}</li>
                        </ul>
                        <p>{translations[lang].job13} <a href="mailto:careers@evokegroup.rs">careers@evokegroup.rs</a> {translations[lang].job131}</p>
                        <p>{translations[lang].job14}</p>
                    </section>

                    <footer id="contact">
                        <div className="top-footer">
                            <h4>{translations[lang].footer1}<br/>{translations[lang].footer12}</h4>
                            <button onClick={handleShow}>{translations[lang].footer2}</button>
                        </div>
                        <div className="bottom-footer">
                            <div className="socials">
                                <img src={logo} alt="evoke logo"/>
                                <div>
                                    <a href="https://www.instagram.com/evoke.marketing.agency/?hl=en" target="_blank"><img src={ig} alt="evoke instagram"/></a>
                                    <a href="https://www.facebook.com/evoke.marketing.agency/" target="_blank"><img src={fb} alt="evoke facebook"/></a>
                                    <a href="https://rs.linkedin.com/company/evoke-rs" target="_blank"><img src={ln} alt="evoke linkedin"/></a>
                                </div>
                            </div>
                            <p>© {translations[lang].footer3}</p>
                        </div>
                    </footer>
                </>
            )}

            {homeShown && (
                <div className={`whole-content ${showContent ? 'active' : ''}`}>

                    <section className="video-section">
                        <video
                            className="desktop"
                            src={desktopVideo}
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                        <video
                            className="mobile"
                            src={mobileVideo}
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                    </section>

                    <div className="header">
                        <a className="logo" href="#" onClick={showHome}><img src={logo} alt="evoke logo"/></a>
                        <div className={`burger ${open ? 'active' : ''}`} onClick={() => setOpen(!open)}>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>

                    <div className={`menu ${open ? 'show' : ''}`}>
                        <a href="#" onClick={showPitch}>{translations[lang].pitch}</a>
                        <a href="#contact">{translations[lang].contact}</a>
                        <a href="#" onClick={showLegal}>Legal</a>
                        <a href="#" onClick={toggleLanguage}>{lang === 'en'? 'SRB': 'EN'}</a>
                    </div>

                    <div className={`page-content ${showContent ? 'active' : ''}`}>

                        <header>
                            <a className="logo" href="#" onClick={showHome}><img src={logo} alt="evoke logo"/></a>
                            <div className="right-nav">
                                <a href="#" onClick={showPitch}>{translations[lang].pitch}</a>
                                <a href="#contact">{translations[lang].contact}</a>
                                <a href="#" onClick={showLegal}>Legal</a>
                                <a href="#" onClick={toggleLanguage}>{lang === 'en'? 'SRB': 'EN'}</a>
                            </div>
                        </header>

                        <div className="hero">
                            <h1>{translations[lang].heroH11} <br/>{translations[lang].heroH12} <br/>{translations[lang].heroH13}</h1>
                        </div>

                        <div className="slider-cont">
                            <div className="slider-cont-top">
                                <h2>{translations[lang].case1}<br/>{translations[lang].case2}</h2>
                                <div className="swiper-navs">
                                    <img ref={prevRef} src={arrowLeft} alt="arrow left" style={{ cursor: 'pointer' }} />
                                    <img ref={nextRef} src={arrowRight} alt="arrow right" style={{ cursor: 'pointer' }} />
                                </div>
                            </div>
                            <Swiper
                                modules={[Navigation]}
                                navigation={{
                                    prevEl: prevRef.current,
                                    nextEl: nextRef.current,
                                }}
                                onBeforeInit={(swiper: { params: { navigation: { prevEl: null; nextEl: null; }; }; }) => {
                                    swiper.params.navigation.prevEl = prevRef.current;
                                    swiper.params.navigation.nextEl = nextRef.current;
                                }}
                                onSwiper={(swiperInstance: any) => {
                                    swiperInstance.slideTo(1)
                                    setTimeout(() => {
                                        if (prevRef2.current && nextRef2.current) {
                                            prevRef2.current.addEventListener('click', () => swiperInstance.slidePrev());
                                            nextRef2.current.addEventListener('click', () => swiperInstance.slideNext());
                                        }
                                    }, 500);
                                }}
                                ref={swiper}
                                spaceBetween={10}
                                slidesPerView={1.2}
                                slidesOffsetBefore={-5}
                                slidesOffsetAfter={-5}
                                loop={true}
                                centeredSlides={true}
                                breakpoints={{
                                    768: {
                                        spaceBetween: 50,
                                        slidesPerView: 1.3,
                                        slidesOffsetAfter: 10,
                                        slidesOffsetBefore: 10
                                    }
                                }}
                            >

                                <SwiperSlide>
                                    <img width="100%" src={case2} alt="slider"/>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width="100%" src={case3} alt="slider"/>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width="100%" src={case4} alt="slider"/>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width="100%" src={case5} alt="slider"/>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img width="100%" src={case6} alt="slider"/>
                                </SwiperSlide>
                            </Swiper>

                            <div className="swiper-navs-mobile">
                                <img ref={prevRef2} src={arrowLeft} alt="arrow left" style={{ cursor: 'pointer' }} />
                                <img ref={nextRef2} src={arrowRight} alt="arrow right" style={{ cursor: 'pointer' }} />
                            </div>
                        </div>

                        <div className="services-cont">
                            <div className="services-cont-top">
                                <h2>{translations[lang].servicesH1}<br/>{translations[lang].servicesH2}<br/>{translations[lang].servicesH3}</h2>
                            </div>
                            <div className="services">
                                <div className="single-service row">
                                    <div className="col-md-1">
                                        <p>01</p>
                                    </div>
                                    <div className="col-md-5">
                                        <h3>{translations[lang].services1Title}</h3>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{translations[lang].services1Content}</p>
                                        <div
                                            ref={contentRef2}
                                            className={`more-services ${isOpen2 ? 'open' : ''}`}
                                            style={{
                                                maxHeight: isOpen2 ? `${contentRef2.current?.scrollHeight}px` : '0px',
                                            }}
                                        >
                                            <div className="single-more-service"><p>{translations[lang].services1Li1}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services1Li2}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services1Li3}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services1Li4}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services1Li5}</p></div>
                                        </div>
                                        <span onClick={toggleServices2} className="toggle-button">
                            {isOpen2 ? translations[lang].seeLess: translations[lang].seeMore}
                        </span>
                                    </div>
                                </div>
                                <div className="single-service row">
                                    <div className="col-md-1">
                                        <p>02</p>
                                    </div>
                                    <div className="col-md-5">
                                        <h3>{translations[lang].services2Title}</h3>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{translations[lang].services2Content}</p>
                                        <div
                                            ref={contentRef}
                                            className={`more-services ${isOpen ? 'open' : ''}`}
                                            style={{
                                                maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px',
                                            }}
                                        >
                                            <div className="single-more-service"><p>{translations[lang].services2Li1}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services2Li2}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services2Li3}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services2Li4}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services2Li5}</p></div>
                                        </div>
                                        <span onClick={toggleServices} className="toggle-button">
                            {isOpen ? translations[lang].seeLess: translations[lang].seeMore}
                        </span>
                                    </div>
                                </div>
                                <div className="single-service row">
                                    <div className="col-md-1">
                                        <p>03</p>
                                    </div>
                                    <div className="col-md-5">
                                        <h3>{translations[lang].services3Title}</h3>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{translations[lang].services3Content}</p>
                                        <div
                                            ref={contentRef3}
                                            className={`more-services ${isOpen3 ? 'open' : ''}`}
                                            style={{
                                                maxHeight: isOpen3 ? `${contentRef3.current?.scrollHeight}px` : '0px',
                                            }}
                                        >
                                            <div className="single-more-service"><p>{translations[lang].services3Li1}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services3Li2}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services3Li3}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services3Li4}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services3Li5}</p></div>
                                        </div>
                                        <span onClick={toggleServices3} className="toggle-button">
                            {isOpen3 ? translations[lang].seeLess: translations[lang].seeMore}
                        </span>
                                    </div>
                                </div>
                                <div className="single-service row">
                                    <div className="col-md-1">
                                        <p>04</p>
                                    </div>
                                    <div className="col-md-5">
                                        <h3>{translations[lang].services4Title}</h3>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{translations[lang].services4Content}</p>
                                        <div
                                            ref={contentRef4}
                                            className={`more-services ${isOpen4 ? 'open' : ''}`}
                                            style={{
                                                maxHeight: isOpen4 ? `${contentRef4.current?.scrollHeight}px` : '0px',
                                            }}
                                        >
                                            <div className="single-more-service"><p>{translations[lang].services4Li1}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services4Li2}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services4Li3}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services4Li4}</p></div>
                                            <div className="single-more-service"><p>{translations[lang].services4Li5}</p></div>
                                        </div>
                                        <span onClick={toggleServices4} className="toggle-button">
                            {isOpen4 ? translations[lang].seeLess: translations[lang].seeMore}
                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="meet-the-process">
                            <img src={mtp} alt="" className="desktop"/>
                            <img src={mtpMobile} alt="" className="mobile"/>
                        </div>

                        <div className="team-cont">
                            <div className="team-cont-top">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h2>{translations[lang].team1}</h2>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{translations[lang].team2}</p>
                                        <p>{translations[lang].team3}</p>
                                    </div>
                                </div>
                            </div>

                            <Swiper
                                className="swiper-team"
                                modules={[Autoplay]}
                                slidesPerView={1.1}
                                spaceBetween={20}
                                loop={true}
                                allowTouchMove={false}
                                speed={5000}
                                autoplay={{
                                    delay: 0,
                                    disableOnInteraction: false,
                                    reverseDirection: true,
                                }}
                                breakpoints={{
                                    768: {
                                        slidesPerView: 4,
                                        spaceBetween: 60
                                    }
                                }}
                            >
                                <SwiperSlide><img src={team1} alt="" /></SwiperSlide>
                                <SwiperSlide><img src={team2} alt="" /></SwiperSlide>
                                <SwiperSlide><img src={team3} alt="" /></SwiperSlide>
                                <SwiperSlide><img src={team4} alt="" /></SwiperSlide>
                                <SwiperSlide><img src={team5} alt="" /></SwiperSlide>
                                <SwiperSlide><img src={team6} alt="" /></SwiperSlide>
                                <SwiperSlide><img src={team7} alt="" /></SwiperSlide>
                                <SwiperSlide><img src={team8} alt="" /></SwiperSlide>
                                <SwiperSlide><img src={team9} alt="" /></SwiperSlide>
                            </Swiper>
                        </div>

                        <div className="clients-cont">
                            <div className="clients-cont-top">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h2>{translations[lang].clients1}</h2>
                                    </div>
                                    <div className="col-md-6">
                                        <p>{translations[lang].clients2}</p>
                                    </div>
                                </div>
                            </div>
                            <Swiper
                                modules={[Autoplay]}
                                slidesPerView={3}
                                spaceBetween={20}
                                loop={true}
                                allowTouchMove={false}
                                speed={5000}
                                autoplay={{
                                    delay: 0,
                                    disableOnInteraction: false
                                }}
                                breakpoints={{
                                    768: {
                                        slidesPerView: 6,
                                        spaceBetween: 60
                                    }
                                }}
                            >
                                <SwiperSlide><img src={ref1} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref2} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref3} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref4} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref5} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref6} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref7} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref8} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref9} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref10} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref11} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref12} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref13} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref14} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref15} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref16} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref17} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref18} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref19} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref20} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref21} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref22} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref23} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref24} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref25} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref26} alt=""/></SwiperSlide>
                                <SwiperSlide><img src={ref27} alt=""/></SwiperSlide>
                            </Swiper>
                        </div>

                        <footer id="contact">
                            <div className="top-footer">
                                <h4>{translations[lang].footer1}<br/>{translations[lang].footer12}</h4>
                                <button onClick={handleShow}>{translations[lang].footer2}</button>
                            </div>
                            <div className="bottom-footer">
                                <div className="socials">
                                    <img src={logo} alt="evoke logo"/>
                                    <div>
                                        <a href="https://www.instagram.com/evoke.marketing.agency/?hl=en" target="_blank"><img src={ig} alt="evoke instagram"/></a>
                                        <a href="https://www.facebook.com/evoke.marketing.agency/" target="_blank"><img src={fb} alt="evoke facebook"/></a>
                                        <a href="https://rs.linkedin.com/company/evoke-rs" target="_blank"><img src={ln} alt="evoke linkedin"/></a>
                                    </div>
                                </div>
                                <p>© {translations[lang].footer3}</p>
                            </div>
                        </footer>
                    </div>


                </div>
            )}

            <Modal
                show={show}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {!submitted && (
                        <form ref={form} method="POST" className="custom-contact-form" onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <input type="text" ref={nameRef} placeholder={translations[lang].form1} required/>
                                </div>
                                <div className="col-md-6">
                                    <input type="email" ref={emailRef} placeholder={translations[lang].form2} required/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <textarea ref={messageRef} rows={10} placeholder={translations[lang].form3} required></textarea>
                                </div>
                            </div>
                            <button type="submit">{translations[lang].form4}</button>
                        </form>
                    )}
                    {submitted && (
                        <p>{translations[lang].confirmation1}<br/>{translations[lang].confirmation2}</p>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default function Root() {
    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
}
